module.exports = __webpack_public_path__ + "img/primary-secondary.70fe166b.jpg";